import queryString from 'query-string';
import { BRIEFS_FILTER_COOKIE_NAME } from 'components/JobsFilterPanel/clearJobsFilters';
import hasUrlFilterParams from './hasUrlFilterParams';

/** `?order=best-match` swaps the listing for Ari (logged-in users only). */
export const BEST_MATCH_ORDER = 'best-match';

/**
 * Same path and filters with `order` set or removed. Page resets because Ari
 * and the listing don't share batches.
 */
export const buildJobsOrderUrl = (pathname, search = '', order = null) => {
  const params = { ...queryString.parse(search) };
  delete params.page;
  if (order) {
    params.order = order;
  } else {
    delete params.order;
  }
  const qs = queryString.stringify(params);
  return qs ? `${pathname}?${qs}` : pathname;
};

/**
 * The saved filters cookie from a Cookie request header. The server reads it
 * itself: react-cookie only reads the browser's cookies.
 *
 * @param {string} header
 * @returns {object|null}
 */
export const parseBriefsFiltersCookie = (header) => {
  const prefix = `${BRIEFS_FILTER_COOKIE_NAME}=`;
  const pair = (header || '')
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));
  if (!pair) {
    return null;
  }
  try {
    const saved = JSON.parse(decodeURIComponent(pair.slice(prefix.length)));
    return saved && typeof saved === 'object' ? saved : null;
  } catch (e) {
    return null;
  }
};

/**
 * The cookie belongs to the browser, so only use what was saved by this
 * user. Cookies saved logged out, or before the user id was added, still
 * apply.
 *
 * @param {object|null} saved
 * @param {object|null} user
 * @returns {boolean}
 */
export const isSavedForUser = (saved, user) =>
  Boolean(saved && user && (saved.userId == null || saved.userId === user.id));

/**
 * Where a bare /jobs visit should go when this user last used Best match,
 * or null. Links with filters or an order keep what they ask for.
 *
 * @param {object} args
 * @param {string} args.pathname
 * @param {string} args.search
 * @param {object|null} args.saved parsed briefsFilters cookie
 * @param {object|null} args.user
 * @returns {string|null}
 */
export const getBestMatchRedirect = ({ pathname, search, saved, user }) => {
  if (
    pathname.replace(/\/$/, '') !== '/jobs' ||
    hasUrlFilterParams(search) ||
    'order' in queryString.parse(search) ||
    !user ||
    !saved ||
    saved.order !== BEST_MATCH_ORDER ||
    saved.userId !== user.id
  ) {
    return null;
  }
  return buildJobsOrderUrl('/jobs', search, BEST_MATCH_ORDER);
};
